import React from 'react';
import { useTranslation } from 'react-i18next';

export function ColorConfig({ obj, handleColor }) {
  const { t } = useTranslation('common');
  return (
    <div className="p-2">
      <p className="mb-2 f-14">{t('CUSTOM_MODULE.COLOR')}</p>
      <div className="border-color-container">
        <input type="color" id="color" onChange={handleColor} value={obj?.otherConfiguration?.color} name="color" />
      </div>
    </div>
  );
}

export default ColorConfig;
